import { useState, useMemo, memo, Dispatch, SetStateAction } from 'react'

import { Button } from '@UI/crypto_exchange/desktop/components/controls/Button'
import InputSelect from '@UI/crypto_exchange/desktop/components/controls/InputSelect'

import cls from './CrossConfigBlock.module.scss'

export default function CrossConfigBlock({ setIsOpen }: { setIsOpen: () => void }) {
  const infoItems = [
    { id: 1, name: 'Hourly Interest Rate', value: '0.00023746%' },
    { id: 2, name: 'Borrowed', value: '0.00000000 BTC' },
    { id: 3, name: 'Maximum Borrow Amount', value: '0.00000000 BTC' },
  ]

  return (
    <div className={cls.block}>
      <InputSelect items={[]} name={''} setValue={() => null} type="alt" label="Coin" />

      <div className={cls.infoContainer}>
        {infoItems.map((item) => (
          <div className={cls.infoRow} key={item.id}>
            <div className={cls.name}>{item.name}</div>
            <div className={cls.value}>{item.value}</div>
          </div>
        ))}
      </div>
      <div className={cls.infoContainer}>
        Maximum borrow amount is subjected to collateral ratio. <span className={cls.link}>Click</span> for more
        information on interest rates, limits and collateral ratio.
      </div>
      <ValueInput />
      <div className={` ${cls.buttonsContainer}`}>
        <div>
          <Button className={cls.btn} size="small" color="dark" onClick={setIsOpen}>
            Cancel
          </Button>
        </div>
        <div>
          <Button className={cls.btn} size="small">
            Confirm Borrow
          </Button>
        </div>
      </div>
    </div>
  )
}

const ValueInput = () => {
  const [selectedSquares, setSelectedSquares] = useState(0)
  const countOfItems = 4
  const step = 100 / countOfItems

  const percentBlocks = useMemo(
    () =>
      Array.from({ length: countOfItems }).map((_, idx) => ({
        id: idx,
        percent: step * (idx + 1),
        selected: idx <= selectedSquares,
      })),
    [selectedSquares],
  )

  return (
    <div>
      <div className={cls.pairLabel}>
        <div>Amount</div>
        <div className={cls.amountContainer}>
          <div className={cls.amountType}>
            <span className={cls.value}>0.000000</span>
            <span className={cls.type}>Available</span>
          </div>
          /
          <div className={cls.amountType}>
            <span className={cls.value}>0.000000</span>
            <span className={cls.type}>in order</span>
          </div>
        </div>
      </div>
      <div className={cls.inputContainer}>
        <input className={cls.valueInput} />
        <div className={cls.max}>MAX</div>
      </div>
      <div className={cls.percentContainer}>
        {percentBlocks.map((block, idx) => (
          <PercentButton
            percent={block.percent}
            key={idx}
            index={idx}
            setSelectedSquares={setSelectedSquares}
            selected={block.selected}
          />
        ))}
      </div>
    </div>
  )
}

const PercentButton = memo(
  ({
    percent,
    index,
    setSelectedSquares,
    selected,
  }: {
    percent: number
    index: number
    setSelectedSquares: Dispatch<SetStateAction<number>>
    selected: boolean
  }) => {
    return (
      <div className={cls.percentButton} onClick={() => setSelectedSquares(index)}>
        <div className={`${cls.percentBlock}  ${selected ? cls.active : ''}`} />
        <div>{percent + '%'}</div>
      </div>
    )
  },
)
